<template>
  <div class="code-edit" style="overflow:hidden">

  </div>
</template>
<script>
  import localHistoryDB from './localHistoryDB'
  export default {
    name: 'MwCodeEdit',
    props: {
      value: {
        type: String,
        default: ''
      },
      lang: {
        type: String,
        default: 'Javascript'
      },
      snippets:[String,Object],
      completeData:Object,
      localHistoryKey:String
    },
    data(){
      return {
        valueChange:false,
        editorChange:false,
        editor:undefined
      }
    },
    mounted() {
      let me=this;
      $WR.ready(function (manager) {
        manager.create({
          xtype: 'CodeEditor',
          lang:me.lang,
          isFormField: false,
          completeData:me.completeData,
          snippets:me.snippets
        }, function(editor) {
          editor.render(me.$el);
          me.editor = editor;
          me.editor.setValue(me.value, false)
          editor.on("change", (v,c) => {
            const val = editor.getValue();
            if (!me.valueChange && val !== me.value) {
              me.editorChange=true;
              me.$emit("input", val);
            }
          });
        })
      });
      if (me.localHistoryKey) {
        me.initLocalHistory();
      }
    },
    watch: {
      value(newVal,oldVal) {
        let me=this
        if(me.editor && !me.editorChange){
          me.valueChange=true;
          me.editor.setValue((me.value=='' || me.value==undefined?'':me.value), false)
        }
        me.valueChange=false;
        me.editorChange=false;
      }
    },
    beforeDestroy() {
      if (this.editor) {
        this.editor.destroy();
        this.editor = null;
      }
    },
    methods: {
      getValue() {
        return this.editor.getValue()
      },
      setValue(val){
        let me=this;
        me.editor.setValue((val==undefined?'':val), false)
      },
      insert: function(row, col, text)
      {
        var session = this.editor.editor.getSession();
        session.insert({row: row, column: col}, text);
      },

      append: function(text)
      {
        var session = this.editor.editor.getSession();
        this.insert(session.getLength(), 0, text);
      },

      find: function(value, caseSensitive)
      {
        var ret = this.editor.editor.find({
          needle: value,
          regExp: true,
          skipCurrent: false,
          backwards: false,
          wrap: true,
          caseSensitive: caseSensitive || false
        });
        this.editor.editor.session.highlight(this.editor.editor.$search.$options.re);
        return ret;
      },

      replace: function(replacement,value,caseSensitive)
      {
        this.editor.editor.replace(replacement,{
          needle: value,
          regExp: true,
          skipCurrent: false,
          backwards: false,
          wrap: true,
          caseSensitive: caseSensitive || false
        });
      },
      initLocalHistory() {
        if(!window.indexedDB)return;
        let me=this;
        let lastValue=me.getValue();
        me.localHistoryInterval=setInterval(()=>{
          let newValue=me.getValue();
          if (newValue && lastValue!==newValue) {
            localHistoryDB.add(me.localHistoryKey,newValue);
            lastValue=newValue;
          }
        },300000);
      }
    },
    destroyed() {
      let i=this.localHistoryInterval;
      if (i) {
        clearInterval(i)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/modules/index/components/code-edit/index.vue